"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolveParentFiltersInput = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = require("react");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
/**
 * @internal
 */
exports.useResolveParentFiltersInput = function (parentFilters, overAttribute) {
    var resolvedParentFilters = sdk_ui_1.useResolveValueWithPlaceholders(parentFilters);
    return react_1.useMemo(function () {
        return getParentFiltersWithOverAttribute(resolvedParentFilters, overAttribute);
    }, [resolvedParentFilters, overAttribute]);
};
var getParentFiltersWithOverAttribute = function (parentFilters, overAttribute) {
    if (!parentFilters || !overAttribute) {
        return [];
    }
    var overAttributeGetter = isFunction_1.default(overAttribute) ? overAttribute : function () { return overAttribute; };
    return parentFilters
        .map(function (attributeFilter, index) {
        return {
            attributeFilter: attributeFilter,
            overAttribute: overAttributeGetter(attributeFilter, index),
        };
    })
        .filter(function (item) {
        return !sdk_model_1.filterIsEmpty(item.attributeFilter);
    });
};
//# sourceMappingURL=useResolveParentFiltersInput.js.map